<template>
  <section class="features">
    <div class="sectionImg" :class="{fs: section.wideScreen}">
      <div class="cnt sectionImgIn">
        <div class="theImg" v-if="section.items && section.items.length > 0 && section.items[0][lang]">
          <div class="imgBg" v-if="section.customCover && section.cover && section.cover[lang]"
            :style="{'background-image': `url(${section.cover[lang].imageLg})`}"></div>
          <div class="imgBg" v-else
            :style="{'background-image': `url(${section.items[0][lang].mainThumb})`}"></div>
        </div>
        <div class="theImg noImg" v-else></div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'sectionImg',
  props: ['section'],
  components: {},
  data() {
    return {
      /**
       * Language
       *
       */
      langCode: 'id-id',
      lang: 'id',
    };
  },
  methods: {},
  mounted() {
    this.langCode = this.$route.params.lang;
    this.lang = this.langCode === 'id-id' ? 'id' : 'en';
  },
};
</script>

<style scoped lang="scss">
.theImg{
  max-width: 840px;
  height: 460px;
  margin: 0 auto;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 5px;
  position: relative;
  .imgBg{
    content: "";
    position: absolute;
    left: 0; top: 0; right: 0; bottom: 0;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 5px;
  }
  &:before{
    content: "";
    position: absolute;
    left: 50%; top: 50%;
    width: 60px; height: 60px;
    border-radius: 50%;
    border: #fff 2px solid;
    background-image: url(../../assets/play-white.png);
    background-size: 24px auto;
    background-position: center;
    background-repeat: no-repeat;
    margin: -30px 0 0 -30px;
    opacity: .6;
    transition: all .3s ease;
    z-index: 3;
  }
  &:after{
    content: "";
    position: absolute;
    left: 0; top: 0; right: 0; bottom: 0;
    opacity: 0;
    background-color: #000;
    transition: all .3s ease;
    z-index: 2;
  }
  &:hover{
    &:before{
      opacity: 1;
    }
    &:after{
      opacity: .34;
    }
  }
  &.noImg{
    background-color: #ccc;
    background-image: url(../../assets/video-black.png);
    background-size: 46px auto;
    opacity: .36;
    &:before, &:after{
      display: none;
    }
  }
}
.fs{
  .theImg{
    max-width: none;
    height: 540px;
  }
}
</style>
